import { createEvent } from '@cobuildlab/react-simple-state';

export const OnDashboard = createEvent();
export const OnDashboardError = createEvent();
export const OnDashboardRevenue = createEvent<(number | null)[]>();
export const OnDashboardRevenueError = createEvent();
